import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { db } from "../firebaseConfig";
// import { storage } from "../firebaseConfig"; // COMENTADO TEMPORARIAMENTE
// import {
//   getAuth,
//   signInAnonymously,
//   createUserWithEmailAndPassword,
//   signOut,
// } from "firebase/auth"; // COMENTADO TEMPORARIAMENTE
import {
  // addDoc,
  // collection,
  doc,
  getDoc,
  // setDoc,
  // runTransaction,
  // serverTimestamp,
} from "firebase/firestore";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // COMENTADO TEMPORARIAMENTE
// import { PDFDocument } from "pdf-lib"; // COMENTADO TEMPORARIAMENTE
import { FaWhatsapp, FaInstagram, FaArrowUp, FaStar, FaGoogle } from "react-icons/fa";
import ataImage from "../assets/ata_logo.png";
import trustedImage from "../assets/trusted.png";
import fundoPonte from "../assets/fundo.png";
import Button from "../components/Button";
import ContactSection from "../components/ContactSection";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { pathFor } from "../lib/i18nRoutes";
import { LANDING_PAGES, NAV_LABELS, LANDING_UI } from "../lib/landingContent";

// import { useNavigate } from "react-router-dom"; // COMENTADO TEMPORARIAMENTE

// Ícones SVG para serviços (removidos por não serem mais utilizados)

// Ícones para processo
const AnalysisIcon = () => (
  <svg
    className="w-8 h-8"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
    />
  </svg>
);

const TranslatorIcon = () => (
  <svg
    className="w-8 h-8"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

const ReviewIcon = () => (
  <svg
    className="w-8 h-8"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const CertificationIcon = () => (
  <svg
    className="w-8 h-8"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
    />
  </svg>
);

// Bandeira da Espanha (vermelho-amarelo-vermelho)

const Home = () => {
  const { t, i18n } = useTranslation();
  const seoLang = ["pt", "es", "en"].includes(i18n.language) ? i18n.language : "pt";
  const seoUi = LANDING_UI[seoLang] || LANDING_UI.pt;
  // Dados dos serviços removidos (layout atual usa conteúdo direto na seção)

  // Etapas do processo baseadas no PDF
  const processSteps = [
    {
      stepNumber: 1,
      title: t("home.processStep1"),
      description: t("home.processStep1Desc"),
      icon: <AnalysisIcon />,
    },
    {
      stepNumber: 2,
      title: t("home.processStep2"),
      description: t("home.processStep2Desc"),
      icon: <TranslatorIcon />,
    },
    {
      stepNumber: 3,
      title: t("home.processStep3"),
      description: t("home.processStep3Desc"),
      icon: <ReviewIcon />,
    },
    {
      stepNumber: 4,
      title: t("home.processStep4"),
      description: t("home.processStep4Desc"),
      icon: <CertificationIcon />,
    },
    {
      stepNumber: 5,
      title: t("home.processStep5"),
      description: t("home.processStep5Desc"),
      icon: <CertificationIcon />,
    },
  ];

  // Vantagens baseadas no PDF
  const advantages = [
    t("home.advantages1"),
    t("home.advantages2"),
    t("home.advantages3"),
    t("home.advantages4"),
    t("home.advantages5"),
  ];

  // Idiomas (não utilizado diretamente; grid abaixo define conteúdo)

  // Informações de contato baseadas no PDF
  const contacts = {
    website: "https://alpha-translations.com/",
    email: "support@alpha-translations.com",
    instagram: "@alpha.translations",
    phone: "+1 (407)-385-9794",
  };
  const whatsappLink = "https://api.whatsapp.com/send?phone=14073859794";

  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };

  // estado simples para espelhar valores no resumo - COMENTADO TEMPORARIAMENTE
  // const [translationType] = useState("Tradução Certificada");
  // const [sourceLang, setSourceLang] = useState("");
  // const [contactName, setContactName] = useState("");
  // const [contactEmail, setContactEmail] = useState("");
  // const [uploadedCount, setUploadedCount] = useState(0);
  // const [selectedFiles, setSelectedFiles] = useState([]);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  // const [isUploading, setIsUploading] = useState(false);
  // const [isSending, setIsSending] = useState(false);
  // const [sendSuccess, setSendSuccess] = useState(false);
  // Campos adicionais semelhantes ao ClientAddProject - COMENTADO TEMPORARIAMENTE
  // const [projectName, setProjectName] = useState("");
  // const [convertCurrency, setConvertCurrency] = useState(false);
  // const [, setIsCertifiedSelected] = useState(true);
  // const [translationRates, setTranslationRates] = useState({
  //   pttoen: 0,
  //   esptoen: 0,
  // });
  // const [valuePerPage, setValuePerPage] = useState(0);
  // const [totalPages, setTotalPages] = useState(0);
  // const [totalValue, setTotalValue] = useState(0);
  // const [hasDocx, setHasDocx] = useState(false);
  // const [isPriority, setIsPriority] = useState(false);
  // const [globalRates, setGlobalRates] = useState({
  //   b2cTimePercentage: 0,
  //   b2cPricePercentage: 0,
  // });
  const [priceHome, setPriceHome] = useState(null); // Mudar de 25 para null
  const [isPriceLoaded, setIsPriceLoaded] = useState(false); // Novo estado para controlar carregamento

  // Estados para reviews do Google
  const [googleReviews, setGoogleReviews] = useState([]);
  const [googleRating, setGoogleRating] = useState(5.0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [reviewsLoading, setReviewsLoading] = useState(true);
  // const [createAccount, setCreateAccount] = useState(false);
  // const [password, setPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");

  // const fileInputRef = useRef(null); // COMENTADO TEMPORARIAMENTE
  // const navigate = useNavigate(); // COMENTADO TEMPORARIAMENTE
  // Refs para sincronizar a altura da imagem (esquerda) com o card de texto (direita) na seção de serviços
  const servicesImageRef = useRef(null);
  const servicesTextRef = useRef(null);

  // const handleFilesSelected = (files) => {
  //   if (!files) return;
  //   const allowed = Array.from(files).filter((file) => {
  //     const type = file.type || "";
  //     const name = (file.name || "").toLowerCase();
  //     return (
  //       type === "application/pdf" ||
  //       type ===
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || // .docx
  //       type === "application/vnd.ms-excel" || // .xls
  //       type ===
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || // .xlsx
  //       type.startsWith("image/") ||
  //       name.endsWith(".pdf") ||
  //       name.endsWith(".docx") ||
  //       name.endsWith(".xls") ||
  //       name.endsWith(".xlsx") ||
  //       name.match(/\.(png|jpe?g|gif|webp)$/)
  //     );
  //   });
  //   setSelectedFiles(allowed);
  //   setUploadedCount(allowed.length);
  // };

  // const uploadSelectedFilesToStorage = async () => {
  //   if (!selectedFiles.length) return [];
  //   setIsUploading(true);
  //   const auth = getAuth();
  //   try {
  //     if (!auth.currentUser) {
  //       await signInAnonymously(auth);
  //     }
  //     const folderKey = (contactEmail || "anon").replace(/[^a-zA-Z0-9]/g, "_");
  //     const uploaded = await Promise.all(
  //       selectedFiles.map(async (file) => {
  //         const fileRef = ref(
  //           storage,
  //           `quotes/${folderKey}/${Date.now()}_${file.name}`
  //       );
  //       await uploadBytes(fileRef, file);
  //       const url = await getDownloadURL(fileRef);
  //       return { name: file.name, url, size: file.size, type: file.type };
  //     })
  //   );
  //   setUploadedFiles(uploaded);
  //   return uploaded;
  // } catch (e) {
  //   console.error("Falha no upload:", e);
  //   alert("Falha no upload. Verifique sua conexão e tente novamente.");
  //   return [];
  // } finally {
  //   setIsUploading(false);
  // }
  // };

  // const handleResetFiles = () => {
  //   // Limpa arquivos e entradas do formulário
  //   setSelectedFiles([]);
  //   setUploadedFiles([]);
  //   setUploadedCount(0);
  //   setContactName("");
  //   setContactEmail("");
  //   setSourceLang("");
  //   setProjectName("");
  //   setConvertCurrency(false);
  //   setIsCertifiedSelected(true);
  //   setSendSuccess(false);
  //   setCreateAccount(false);
  //   setPassword("");
  //   setConfirmPassword("");
  //   if (fileInputRef.current) {
  //     fileInputRef.current.value = "";
  //   }
  // };

  // const computeValuePerPage = useCallback(
  //   (source) => {
  //     const s = (source || "")
  //       .toLowerCase()
  //       .trim()
  //       .normalize("NFD")
  //       .replace(/[\u0300-\u036f]/g, "");
  //     if (s.includes("portugues")) return Number(translationRates.pttoen) || 0;
  //     if (s.includes("espanhol")) return Number(translationRates.esptoen) || 0;
  //     return 0;
  //   },
  //   [translationRates]
  // );

  // const countPdfPages = async (file) => {
  //   try {
  //     const buffer = await file.arrayBuffer();
  //     const pdf = await PDFDocument.load(buffer);
  //       return pdf.getPageCount();
  //   } catch (e) {
  //     console.error("Erro ao contar páginas do PDF:", e);
  //     return 0;
  //   }
  // };

  // Buscar valores padrão por página (priceperpage/price) - COMENTADO TEMPORARIAMENTE
  // React.useEffect(() => {
  //   (async () => {
  //     try {
  //       const priceRef = doc(db, "priceperpage", "price");
  //       const snap = await getDoc(priceRef);
  //       if (snap.exists()) {
  //         const data = snap.data();
  //         setTranslationRates({
  //           pttoen: Number(data.pttoen) || 0,
  //           esptoen: Number(data.esptoen) || 0,
  //         });
  //         setGlobalRates({
  //           b2cTimePercentage: Number(data.b2cTimePercentage) || 0,
  //           b2cPricePercentage: Number(data.b2cPricePercentage) || 0,
  //         });
  //         // Buscar preço para home
  //         if (data.price_home) {
  //           setPriceHome(Number(data.price_home));
  //           setIsPriceLoaded(true);
  //         }
  //       }
  //     } catch (e) {
  //       console.error("Erro ao buscar priceperpage/price:", e);
  //     }
  //   })();
  // }, []);

  // Buscar preço para home - RESTAURADO
  React.useEffect(() => {
    (async () => {
      try {
        const priceRef = doc(db, "priceperpage", "price");
        const snap = await getDoc(priceRef);
        if (snap.exists()) {
          const data = snap.data();
          // Buscar preço para home
          if (data.price_home) {
            setPriceHome(Number(data.price_home));
            setIsPriceLoaded(true);
          }
        }
      } catch (e) {
        console.error("Erro ao buscar priceperpage/price:", e);
      }
    })();
  }, []);

  // Buscar reviews do Google do Firestore
  React.useEffect(() => {
    (async () => {
      try {
        setReviewsLoading(true);
        const reviewsRef = doc(db, "settings", "google_reviews");
        const snap = await getDoc(reviewsRef);

        if (snap.exists()) {
          const data = snap.data();
          setGoogleReviews(data.reviews || []);
          setGoogleRating(data.rating || 5.0);
          setTotalReviews(data.total_reviews || 0);
        }
      } catch (e) {
        console.error("Erro ao buscar reviews do Firestore:", e);
      } finally {
        setReviewsLoading(false);
      }
    })();
  }, []);

  // Recalcular páginas/valor/prazo com base nos arquivos/idioma/prioridade - COMENTADO TEMPORARIAMENTE
  // React.useEffect(() => {
  //   let cancelled = false;
  //   (async () => {
  //     if (!selectedFiles.length) {
  //       setHasDocx(false);
  //       setTotalPages(0);
  //       setValuePerPage(0);
  //       setTotalValue(0);

  //       return;
  //     }

  //     const vp = computeValuePerPage(sourceLang);
  //     const hasAnyDocx = selectedFiles.some((f) => {
  //       const type = f.type || "";
  //       const name = (f.name || "").toLowerCase();
  //       return (
  //         type ===
  //           "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
  //         name.endsWith(".docx")
  //       );
  //     });

  //     let pages = 0;
  //     const pdfs = selectedFiles.filter(
  //       (f) =>
  //         (f.type || "") === "application/pdf" ||
  //         (f.name || "").toLowerCase().endsWith(".pdf")
  //     );
  //     const images = selectedFiles.filter((f) =>
  //       (f.type || "").startsWith("image/")
  //     );

  //     try {
  //       const pdfCounts = await Promise.all(pdfs.map((f) => countPdfPages(f)));
  //       pages =
  //         pdfCounts.reduce((sum, n) => sum + (Number.isFinite(n) ? n : 0), 0) +
  //         images.length;
  //     } catch (e) {
  //       console.error("Falha ao contar páginas de PDFs:", e);
  //     }

  //     if (cancelled) return;
  //     setHasDocx(hasAnyDocx);
  //     const adjustedVP = isPriority
  //       ? Number(vp) * (1 + (Number(globalRates.b2cPricePercentage) || 0) / 100)
  //       : Number(vp);
  //     setValuePerPage(adjustedVP);
  //     setTotalPages(pages);
  //     setTotalValue(adjustedVP * Number(pages));
  //   })();
  //   return () => {
  //     cancelled = true;
  //   };
  // }, [selectedFiles, sourceLang, computeValuePerPage, isPriority, globalRates]);

  // Sincroniza a altura da imagem com a altura do card de texto na seção "Tradução Certificada nos EUA"
  React.useEffect(() => {
    const syncHeights = () => {
      const imgCol = servicesImageRef.current;
      const textCol = servicesTextRef.current;
      if (imgCol && textCol) {
        imgCol.style.height = `${textCol.offsetHeight}px`;
      }
    };
    syncHeights();
    window.addEventListener("resize", syncHeights);
    return () => window.removeEventListener("resize", syncHeights);
  }, []);

  // const generateProjectNumber = async () => {
  //   try {
  //     const counterRef = doc(db, "counters", "projects");
  //     const newNumber = await runTransaction(db, async (transaction) => {
  //       const counterDoc = await transaction.get(counterRef);
  //       if (!counterDoc.exists()) {
  //         transaction.set(counterRef, { count: 1 });
  //         return 1;
  //       }
  //       const current = counterDoc.data().count || 0;
  //       const next = current + 1;
  //       transaction.update(counterRef, { count: next });
  //         return next;
  //     });
  //     return String(newNumber);
  //   } catch (e) {
  //     console.error("Erro ao gerar número do projeto:", e);
  //     return String(Date.now());
  //   }
  // };

  // const handleSend = async () => {
  //   if (!isReadyToSend) return;
  //   setIsSending(true);
  //   try {
  //     // Garantir autenticação antes de gravar em Firestore
  //     const auth = getAuth();
  //     if (!auth.currentUser) {
  //       await signInAnonymously(auth);
  //     }

  //     // Se o usuário optou por criar conta, criar SEM manter sessão logada
  //     if (createAccount && contactEmail && password) {
  //       try {
  //         // Criar conta (isto autentica), gravar doc de usuário e sair em seguida
  //         const userCred = await createUserWithEmailAndPassword(
  //           auth,
  //           contactEmail,
  //           password
  //         );

  //         // Buscar valores padrão pttoen/esptoen
  //         let pttoen = 0;
  //         let esptoen = 0;
  //         try {
  //           const priceRef = doc(db, "priceperpage", "price");
  //           const snap = await getDoc(priceRef);
  //           if (snap.exists()) {
  //             const data = snap.data();
  //             pttoen = data.pttoen ?? 0;
  //             pttoen = data.esptoen ?? 0;
  //           }
  //         } catch (e) {
  //           console.warn("Falha ao buscar priceperpage ao registrar b2c:", e);
  //         }

  //         await setDoc(doc(db, "users", userCred.user.uid), {
  //           nomeCompleto: contactName,
  //           email: contactEmail,
  //           userType: "b2c",
  //           registeredBy: null,
  //           registeredByType: null,
  //           createdAt: new Date(),
  //           pttoen,
  //           esptoen,
  //           canTest: false,
  //         });

  //         // Sair e voltar para sessão anônima
  //         await signOut(auth);
  //         await signInAnonymously(auth);
  //       } catch (err) {
  //         console.error("Falha ao criar conta no Enviar:", err);
  //       }
  //     }
  //     const projectNumber = await generateProjectNumber();
  //     const uploaded = uploadedFiles.length
  //       ? uploadedFiles
  //       : await uploadSelectedFilesToStorage();
  //     if (createAccount) {
  //       // Para DOCX/planilhas com conta criada: salvar como B2C (regras do ClientAddProject)
  //       const filesSummary = (uploaded || []).map((f) => ({
  //         name: f.name,
  //         pageCount: 0,
  //         valuePerPage: 0,
  //         total: 0,
  //         requiresManualQuote: true,
  //         }));
  //       const projectData = {
  //         createdAt: serverTimestamp(),
  //         projectNumber,
  //         projectName: projectName || "Cotação Online",
  //         projectOwner: contactName || "Cliente",
  //         sourceLanguage: sourceLang || "",
  //         targetLanguage: "Inglês",
  //         totalPages: 0,
  //         totalProjectValue: 0,
  //         deadline: "",
  //         deadlineDate: "",
  //         isPriority: isPriority || false,
  //         files: filesSummary,
  //         userEmail: contactEmail,
  //         registeredBy: null,
  //         registeredByType: null,
  //         project_status: "Rascunho",
  //         payment_status: "Pendente",
  //         translation_status: "N/A",
  //         valuePerPage: 0,
  //         hasManualQuoteFiles: true,
  //         convertCurrency: Boolean(convertCurrency),
  //       };
  //       await addDoc(collection(db, "b2cdocsaved"), projectData);
  //     } else {
  //       const quoteDoc = {
  //         createdAt: serverTimestamp(),
  //         projectNumber,
  //         contactName,
  //         contactEmail,
  //         createAccount: Boolean(createAccount),
  //         sourceLanguage: sourceLang || null,
  //         targetLanguage: "Inglês",
  //         translationType,
  //         files: uploaded,
  //         totalFiles: uploaded.length || selectedFiles.length || 0,
  //         status: "pending_review",
  //       };
  //       await addDoc(collection(db, "quotes"), quoteDoc);
  //     }
  //     // Feedback: mensagem que some após 5 segundos
  //     setSendSuccess(true);
  //     setTimeout(() => setSendSuccess(false), 5000);
  //     // Reset parcial
  //     setSelectedFiles([]);
  //     setUploadedFiles([]);
  //     setUploadedCount(0);
  //   } catch (e) {
  //     console.error("Erro ao enviar cotação:", e);
  //     alert("Falha ao enviar cotação. Tente novamente.");
  //   } finally {
  //     setIsSending(false);
  //   }
  // };

  // const handlePay = async () => {
  //   if (!isReadyToSend || hasDocx || totalValue <= 0) return;
  //   try {
  //     const auth = getAuth();
  //     // Se o usuário optou por criar conta, criar SEM manter sessão logada
  //     if (createAccount && contactEmail && password) {
  //       try {
  //         const userCred = await createUserWithEmailAndPassword(
  //           auth,
  //           contactEmail,
  //           password
  //         );
  //         // Buscar valores padrão pttoen/esptoen
  //         let pttoen = 0;
  //         let esptoen = 0;
  //       try {
  //         const priceRef = doc(db, "priceperpage", "price");
  //         const snap = await getDoc(priceRef);
  //         if (snap.exists()) {
  //           const data = snap.data();
  //           pttoen = data.pttoen ?? 0;
  //           esptoen = data.esptoen ?? 0;
  //         }
  //       } catch (e) {
  //         console.warn("Falha ao buscar priceperpage ao registrar b2c:", e);
  //       }
  //       await setDoc(doc(db, "users", userCred.user.uid), {
  //         nomeCompleto: contactName,
  //         email: contactEmail,
  //         userType: "b2c",
  //         registeredBy: null,
  //         registeredByType: null,
  //         createdAt: new Date(),
  //         pttoen,
  //         esptoen,
  //         canTest: false,
  //       });
  //       // Sair e voltar para anônimo para seguir com pagamento como visitante
  //       await signOut(auth);
  //       await signInAnonymously(auth);
  //     } catch (err) {
  //       console.error("Falha ao criar conta no Pagar:", err);
  //       alert(
  //         err?.code === "auth/email-already-in-use"
  //           ? "E-mail já cadastrado. Faça login ou use outro e-mail."
  //           : "Não foi possível criar a conta. Verifique os dados e tente novamente."
  //       );
  //       // Mesmo com erro de criação de conta, permitir seguir com pagamento como visitante
  //       if (!auth.currentUser) {
  //         await signInAnonymously(auth);
  //       }
  //     }
  //   } else if (!auth.currentUser) {
  //     await signInAnonymously(auth);
  //   }

  //   const projectNumber = await generateProjectNumber();
  //   const collectionName = createAccount ? "b2csketch" : "quotes";
  //   const filesSummary = [
  //     {
  //       name: "Documento(s) PDF/Imagem",
  //       pageCount: totalPages,
  //       valuePerPage: valuePerPage,
  //       total: totalValue,
  //     },
  //   ];
  //   const projectData = {
  //     createdAt: serverTimestamp(),
  //     projectNumber: projectNumber,
  //     projectName: projectName || "Cotação Online",
  //     projectOwner: contactName || "Cliente",
  //     sourceLanguage: sourceLang || "",
  //     targetLanguage: "Inglês",
  //     totalPages: totalPages,
  //     totalProjectValue: totalValue,
  //     isPriority: isPriority || false,
  //     files: filesSummary,
  //     userEmail: contactEmail,
  //     createAccount: Boolean(createAccount),
  //     status: createAccount ? "Rascunho" : "pending_payment",
  //     valuePerPage: valuePerPage,
  //     hasManualQuoteFiles: false,
  //     convertCurrency: false,
  //     ...(createAccount
  //       ? {
  //           registeredBy: contactEmail,
  //           registeredByType: "b2c",
  //           project_status: "Rascunho",
  //           payment_status: "Pendente",
  //           translation_status: "N/A",
  //         }
  //       : {}),
  //   };
  //   const refCol = collection(db, collectionName);
  //   const saved = await addDoc(refCol, projectData);

  //   // Criar PaymentIntent no Stripe antes de navegar
  //   try {
  //     // URL da função Firebase (será configurada via variável de ambiente)
  //     const functionUrl =
  //       process.env.REACT_APP_FIREBASE_FUNCTION_URL ||
  //       "https://us-central1-alpha-translations.cloudfunctions.net";
  //     const response = await fetch(`${functionUrl}/createPaymentIntent`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         amount: Math.round(totalValue * 100), // Stripe usa centavos
  //         project_id: saved.id,
  //         metadata: {
  //           project_ids: saved.id,
  //           project_collections: collectionName,
  //           payment_type: "normal",
  //           client_email: contactEmail,
  //           client_name: contactName,
  //         },
  //       }),
  //     });

  //     if (!response.ok) {
  //       const errorText = await response.text();
  //       console.error(
  //         "❌ Home.js - Resposta não OK:",
  //         response.status,
  //         errorText
  //       );
  //       throw new Error(
  //         "Falha ao criar PaymentIntent: ${response.status} - ${errorText}"
  //       );
  //     }

  //     const responseData = await response.json();
  //     console.log("🔑 Home.js - Resposta completa:", responseData);

  //     const { clientSecret } = responseData;

  //     // Debug: verificar se clientSecret foi obtido
  //     console.log("🔑 Home.js - clientSecret obtido:", clientSecret);
  //     console.log("🔑 Home.js - Tipo do clientSecret:", typeof clientSecret);

  //     const params = new URLSearchParams({
  //       project_ids: saved.id,
  //       project_collections: collectionName,
  //       payment_type: "normal",
  //       total_value: totalValue.toFixed(2),
  //       project_name: projectData.projectName,
  //       project_number: `#${projectNumber}`,
  //       client_name: contactName,
  //       client_email: contactEmail,
  //       source_language: sourceLang || "",
  //       target_language: "Inglês",
  //       client_secret: clientSecret, // Adicionar client_secret
  //     });

  //     // Debug: verificar URL final
  //     const finalUrl = `/payment?${params.toString()}`;
  //     console.log("🔑 Home.js - URL final gerada:", finalUrl);
  //     console.log(
  //       "🔑 Home.js - Parâmetros da URL:",
  //       Object.fromEntries(params);
  //     );

  //     navigate(finalUrl);
  //   } catch (stripeError) {
  //     console.error("Erro ao criar PaymentIntent:", stripeError);
  //     alert("Falha ao processar pagamento. Tente novamente.");
  //   }
  // } catch (e) {
  //   console.error("Erro ao salvar projeto para pagamento:", e);
  //   alert("Falha ao iniciar pagamento. Tente novamente.");
  // }
  // };

  // const isReadyToSend =
  //   Boolean(sourceLang) &&
  //   contactName.trim().length > 0 &&
  //   /\S+@\S+\.\S+/.test(contactEmail) &&
  //   (!createAccount || (password.length >= 6 && password === confirmPassword));

  // const hasChanges =
  //   uploadedCount > 0 ||
  //   uploadedFiles.length > 0 ||
  //   contactName.trim().length > 0 ||
  //   contactEmail.trim().length > 0 ||
  //   Boolean(sourceLang);

  // Removido: sincronismo de alturas entre colunas para evitar alongamento desnecessário

  return (
    <div className="min-h-screen bg-white overflow-x-hidden box-border">
      <Seo
        title="Tradução Juramentada e Certificada — Português, Espanhol e Inglês"
        description="Tradução juramentada no Brasil e certificada aceita pelo USCIS para imigração nos EUA. Documentos para vistos, universidades e órgãos oficiais em Português, Espanhol e Inglês. Tradutores membros da ATA. Orçamento na hora."
        path="/"
      />
      {/* Seção Principal */}
      <section
        id="inicio"
        className="w-full py-10 sm:py-0 sm:min-h-[100svh] bg-white text-black flex flex-col sm:flex-row items-center justify-center px-2 sm:px-0 overflow-x-hidden box-border"
        style={{
          backgroundImage: `url(${fundoPonte})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right bottom",
          backgroundSize: "auto 100%",
        }}
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="w-full max-w-2xl mx-auto ml-auto mr-auto md:ml-0 md:mr-auto">
            <div className="bg-white/40 backdrop-blur-sm rounded-2xl p-4 sm:p-6 md:p-8 shadow-lg border border-white/30 flex flex-col justify-center relative w-full max-w-full box-border min-h-[60vh] sm:min-h-[500px] md:min-h-[600px]">
              {/* Tarja de preço na quina superior direita */}
              {isPriceLoaded && priceHome && (
                <div className="absolute top-2 right-2 sm:-top-2 sm:-right-2 bg-gradient-to-r from-red-500 to-red-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-bl-lg sm:rounded-bl-lg z-10">
                  <div className="text-center">
                    <div className="text-[10px] sm:text-xs opacity-90 mb-0.5">
                      {t("home.startingFrom")}
                    </div>
                    <div className="text-lg sm:text-2xl font-bold">
                      ${priceHome}
                    </div>
                    <div className="text-[10px] sm:text-xs opacity-90">
                      {t("home.perPage")}
                    </div>
                  </div>
                </div>
              )}


              <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-center sm:text-left pt-16 sm:pt-0">
                Alpha Translations
              </h1>
              <p className="mt-2 text-base sm:text-xl md:text-2xl text-center sm:text-left">
                {t("home.professionalServices")}
              </p>
              <p className="mt-1 text-sm sm:text-lg md:text-xl text-center sm:text-left">
                {t("home.individualCorporate")}
              </p>
              <p className="mt-3 text-sm sm:text-lg md:text-xl font-semibold text-gray-800 text-center sm:text-left">
                {t("home.uscisAcceptedText")}
              </p>

              {/* Logos das certificações (inline, sem quebra) */}
              <div className="mt-6 flex items-center justify-center sm:justify-start gap-4 sm:gap-6 md:gap-8 w-full">
                <a href="https://www.atanet.org/member-directory/alpha-translations-llc/" target="_blank" rel="noopener noreferrer">
                  <img
                    src={ataImage}
                    alt="American Translators Association"
                    className="object-contain h-10 sm:h-11 md:h-12 w-auto"
                    loading="lazy"
                    decoding="async"
                  />
                </a>
                <img
                  src={trustedImage}
                  alt="ATA Corporate Member"
                  className="object-contain h-10 sm:h-11 md:h-12 w-auto"
                  loading="lazy"
                  decoding="async"
                />
                <a
                  href="https://www.bbb.org/us/fl/orlando/profile/translators/alpha-translations-0733-235975216/#sealclick"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://seal-centralflorida.bbb.org/seals/blue-seal-250-52-bbb-235975216.png"
                    style={{ border: 0, height: "40px", width: "auto" }}
                    alt="Alpha Translations BBB Business Review"
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              </div>

              <div className="mt-8 sm:mt-10 md:mt-12 lg:mt-16 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-3 w-full max-w-full mx-auto sm:mx-0">
                <a href="/login" className="block w-full">
                  <Button
                    size="lg"
                    rounded="full"
                    className="w-full rounded-full bg-blue-600 hover:bg-blue-700"
                  >
                    {t("home.placeOrderButton")}
                  </Button>
                </a>
                <a href="#servicos" className="block w-full">
                  <Button
                    variant="secondary"
                    size="lg"
                    rounded="full"
                    className="w-full rounded-full bg-gray-200 hover:bg-gray-300 text-gray-800"
                  >
                    {t("home.servicesButton")}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção "Quem Somos" */}
      <section
        className="w-full bg-gray-50 py-10 sm:py-20 md:py-24 lg:py-32 min-h-[400px] sm:min-h-[680px] md:min-h-[760px] lg:min-h-[840px] overflow-x-hidden box-border"
        id="sobre"
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="text-center mb-8 sm:mb-16 md:mb-20 lg:mb-28">
            <h2 className="text-xl sm:text-2xl md:text-4xl font-semibold text-gray-900">
              {t("home.aboutTitle")}
            </h2>
            <p className="mt-2 text-sm sm:text-base md:text-lg text-gray-600 max-w-3xl mx-auto sm:mx-auto">
              {t("home.aboutDescription")}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-4 sm:gap-8 md:gap-10 items-start w-full max-w-full">
            <div className="col-span-6 md:col-span-6 lg:col-span-5 order-2 lg:order-1 w-full max-w-full">
              <div className="overflow-hidden rounded-2xl w-full max-w-full">
                <img
                  src={require("../assets/office.webp")}
                  alt={t("home.officeTitle")}
                  className="w-full max-w-full h-32 sm:h-48 md:h-64 lg:h-80 object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            <div className="col-span-6 md:col-span-6 lg:col-span-7 order-1 lg:order-2 space-y-4 sm:space-y-6 w-full max-w-full">
              <div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {t("home.mission")}
                </h3>
                <p className="mt-2 text-gray-700 leading-relaxed">
                  {t("home.missionDescription")}
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                <div>
                  <h4 className="text-base font-semibold text-gray-900">
                    {t("home.qualityReliability")}
                  </h4>
                  <p className="mt-1 text-gray-700">
                    {t("home.qualityDescription")}
                  </p>
                </div>
                <div>
                  <h4 className="text-base font-semibold text-gray-900">
                    {t("home.binationalExperience")}
                  </h4>
                  <p className="mt-1 text-gray-700">
                    {t("home.binationalDescription")}
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:gap-x-8 sm:gap-y-4 pt-4 border-t border-gray-200">
                <div>
                  <div className="text-2xl font-semibold text-gray-900">
                    5000+
                  </div>
                  <div className="text-sm text-gray-500">
                    {t("home.projectsCompleted")}
                  </div>
                </div>
                <div className="h-6 w-px bg-gray-200 hidden sm:block"></div>
                <div>
                  <div className="text-2xl font-semibold text-gray-900">
                    100%
                  </div>
                  <div className="text-sm text-gray-500">
                    {t("home.approvalRate")}
                  </div>
                </div>
                <div className="h-6 w-px bg-gray-200 hidden sm:block"></div>
                <div>
                  <div className="text-2xl font-semibold text-gray-900">
                    USCIS
                  </div>
                  <div className="text-sm text-gray-500 flex items-center gap-1">
                    <span className="text-green-600">✓</span>
                    {t("home.uscisAccepted")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção "Nossos Serviços" */}
      <section
        className="w-full bg-gray-50 py-10 sm:py-20 md:py-24 lg:py-24 min-h-[300px] sm:min-h-[560px] md:min-h-[640px] lg:min-h-[720px] overflow-x-hidden box-border"
        id="servicos"
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
              {t("home.servicesCertified")}
            </h2>
            <p className="mt-1 text-base sm:text-lg text-gray-600">
              {t("home.servicesSubtitle")}
            </p>
          </div>

          {/* Tradução Certificada - imagem com padrão da seção "Escritório Alpha Translations" */}
          <div className="mt-8 sm:mt-12 grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-4 sm:gap-6 md:gap-8 items-stretch w-full max-w-full">
            <div
              ref={servicesImageRef}
              className="col-span-6 md:col-span-4 lg:col-span-8 overflow-hidden rounded-2xl order-2 lg:order-1 h-40 sm:h-full w-full max-w-full"
            >
              <img
                src={require("../assets/uscis_pic.png")}
                alt="Tradução Certificada nos EUA"
                className="w-full max-w-full h-full object-cover object-center"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div
              ref={servicesTextRef}
              className="col-span-6 md:col-span-2 lg:col-span-4 bg-white rounded-2xl border border-gray-200 p-3 sm:p-6 flex flex-col order-1 lg:order-2 h-full w-full max-w-full box-border"
            >
              <h3 className="text-xl font-semibold text-gray-900">
                {t("home.servicesCertified")}
              </h3>
              <p className="mt-3 text-gray-700">
                {t("home.certifiedDescription")}
              </p>
              <p className="mt-3 text-gray-700 leading-relaxed">
                {t("home.certifiedDescription2")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção "Nosso Processo de Tradução" */}
      <section
        className="w-full bg-white py-10 sm:py-20 md:py-24 lg:py-24 min-h-[300px] sm:min-h-[680px] md:min-h-[760px] lg:min-h-[800px] overflow-x-hidden box-border"
        id="processo"
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
              {t("home.processTitle")}
            </h2>
            <p className="mt-1 text-base sm:text-lg text-gray-600">
              {t("home.processSubtitle")}
            </p>
          </div>

          {/* Processo de tradução com layout moderno e simétrico */}
          <div className="mt-8 sm:mt-12 relative w-full max-w-full">
            {/* Linha conectora horizontal (desktop) */}
            <div className="hidden lg:block absolute top-8 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200" />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-4 w-full max-w-full">
              {processSteps.map((step, index) => (
                <div key={index} className="relative group">
                  {/* Card do processo */}
                  <div className="bg-white rounded-2xl border border-gray-200 p-4 md:p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:border-blue-300 relative z-10 h-full flex flex-col">
                    {/* Ícone e número */}
                    <div className="flex flex-col items-center text-center mb-4">
                      <div className="relative mb-3">
                        <div className="w-16 h-16 bg-gradient-to-br from-blue-200 via-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 hover:scale-105 transform border border-blue-200">
                          <span className="text-blue-700 font-semibold text-xl">
                            {step.stepNumber}
                          </span>
                        </div>
                      </div>

                      {/* Título */}
                      <h3 className="text-lg sm:text-base md:text-xl font-semibold text-gray-900 mb-2">
                        {step.title}
                      </h3>
                    </div>

                    {/* Descrição */}
                    <p className="text-sm sm:text-sm md:text-base text-gray-700 leading-relaxed text-center flex-1 flex items-center justify-center">
                      {step.description}
                    </p>
                  </div>

                  {/* Indicador de progresso (mobile) */}
                  {index < processSteps.length - 1 && (
                    <div className="lg:hidden flex justify-center mt-4">
                      <div className="w-8 h-0.5 bg-gradient-to-r from-blue-200 to-blue-400 rounded-full" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Seção "Nossos Idiomas" */}
      <section
        className="w-full bg-gray-50 py-10 sm:py-20 md:py-24 lg:py-24 min-h-[300px] sm:min-h-[560px] md:min-h-[640px] lg:min-h-[720px] overflow-x-hidden box-border"
        id="idiomas"
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
              {t("home.languagesTitle")}
            </h2>
            <p className="mt-1 text-base sm:text-lg text-gray-600">
              {t("home.languagesSubtitle")}
            </p>
          </div>

          {/* Grid de idiomas moderno e elegante */}
          <div className="mt-8 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 w-full max-w-full">
            {[
              {
                key: "br",
                label: t("home.languagesPortuguese"),
                direction: "PT → EN",
                flag: require("../assets/bra.jpg"),
                bgColor: "bg-white",
                textColor: "text-gray-800",
                borderColor: "border-gray-200",
              },
              {
                key: "es",
                label: t("home.languagesSpanish"),
                direction: "ES → EN",
                flag: require("../assets/esp.jpeg"),
                bgColor: "bg-white",
                textColor: "text-gray-800",
                borderColor: "border-gray-200",
              },
              {
                key: "us",
                label: t("home.languagesEnglish"),
                direction: "EN",
                flag: require("../assets/usa.jpg"),
                bgColor: "bg-white",
                textColor: "text-gray-800",
                borderColor: "border-gray-200",
              },
              {
                key: "other",
                label: t("home.languagesOthers"),
                direction: "+20",
                flag: require("../assets/other_languages_icon.png"),
                bgColor: "bg-white",
                textColor: "text-gray-800",
                borderColor: "border-gray-200",
              },
            ].map((lang) => (
              <div
                key={lang.key}
                className={`group relative overflow-hidden rounded-2xl border-2 ${lang.borderColor} ${lang.bgColor} p-6 hover:shadow-lg transition-all duration-300 hover:scale-105`}
              >
                {/* Globo com bandeira do país */}
                <div className="text-center mb-4">
                  <div className="w-20 h-20 mx-auto mb-3 relative">
                    <div className="w-full h-full rounded-full bg-gradient-to-br from-blue-400 to-blue-600 shadow-lg overflow-hidden">
                      {/* Meridianos */}
                      <div className="absolute inset-0 rounded-full border-2 border-white/30 opacity-60"></div>
                      {/* Paralelos */}
                      <div className="absolute inset-0 rounded-full border-2 border-white/30 opacity-40 transform rotate-90"></div>
                      {/* Bandeira do país ocupando todo o globo */}
                      <div className="absolute inset-0 flex items-center justify-center">
                        <img
                          src={lang.flag}
                          alt={`Bandeira ${lang.label}`}
                          className="w-full h-full object-cover rounded-full"
                          loading="lazy"
                          decoding="async"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Conteúdo principal */}
                <div className="relative z-10">
                  {/* Título */}
                  <h3
                    className={`text-xl font-bold ${lang.textColor} mb-3 text-center`}
                  >
                    {lang.label}
                  </h3>

                  {/* Descrição */}
                  <p className="mt-4 text-gray-600 text-sm leading-relaxed text-center">
                    {lang.key === "br" && t("home.languageDescriptionPT")}
                    {lang.key === "es" && t("home.languageDescriptionES")}
                    {lang.key === "us" && t("home.languageDescriptionEN")}
                    {lang.key === "other" && t("home.languageDescriptionOther")}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Seção "Vantagens Alpha" */}
      <section
        className="w-full bg-white py-10 sm:py-20 md:py-24 lg:py-24 min-h-[300px] sm:min-h-[560px] md:min-h-[640px] lg:min-h-[720px] overflow-x-hidden box-border"
        id="vantagens"
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
              {t("home.advantagesTitle")}
            </h2>
            <p className="mt-1 text-base sm:text-lg text-gray-600">
              {t("home.advantagesSubtitle")}
            </p>
          </div>

          <div className="mt-6 sm:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 lg:gap-10 w-full max-w-full">
            {advantages.map((item, index) => (
              <div key={index} className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 text-green-700 text-sm">
                  ✓
                </span>
                <span className="text-gray-800 leading-relaxed">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Seção de Reviews do Google */}
      <section
        className="w-full bg-gray-50 py-10 sm:py-20 md:py-24 lg:py-24 min-h-[300px] sm:min-h-[500px] overflow-x-hidden box-border"
        id="reviews"
      >
        <div className="w-full px-4 md:px-6 mx-auto max-w-7xl">
          <div className="text-center mb-8 sm:mb-12">
            <div className="flex items-center justify-center gap-2 mb-2">
              <FaGoogle className="text-2xl sm:text-3xl text-blue-500" />
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <FaStar
                    key={i}
                    className={`text-lg sm:text-xl ${
                      i < Math.round(googleRating) ? "text-yellow-400" : "text-gray-300"
                    }`}
                  />
                ))}
              </div>
              <span className="text-lg sm:text-xl font-semibold text-gray-700 ml-1">
                {googleRating.toFixed(1)}
              </span>
              {totalReviews > 0 && (
                <span className="text-sm text-gray-500 ml-1">
                  ({totalReviews})
                </span>
              )}
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
              {t("home.reviewsTitle")}
            </h2>
            <p className="mt-1 text-base sm:text-lg text-gray-600">
              {t("home.reviewsSubtitle")}
            </p>
          </div>

          {reviewsLoading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          ) : googleReviews.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
              {googleReviews.slice(0, 6).map((review, index) => {
                const colors = [
                  "from-blue-500 to-blue-600",
                  "from-green-500 to-green-600",
                  "from-purple-500 to-purple-600",
                  "from-orange-500 to-orange-600",
                  "from-pink-500 to-pink-600",
                  "from-teal-500 to-teal-600",
                ];
                const colorClass = colors[index % colors.length];
                const initial = review.author_name ? review.author_name.charAt(0).toUpperCase() : "?";

                return (
                  <div
                    key={index}
                    className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-all duration-300"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      {review.profile_photo_url ? (
                        <img
                          src={review.profile_photo_url}
                          alt={review.author_name}
                          className="w-12 h-12 rounded-full object-cover"
                        />
                      ) : (
                        <div
                          className={`w-12 h-12 rounded-full bg-gradient-to-br ${colorClass} flex items-center justify-center text-white font-semibold text-lg`}
                        >
                          {initial}
                        </div>
                      )}
                      <div>
                        <h4 className="font-semibold text-gray-900">
                          {review.author_name}
                        </h4>
                        <div className="flex items-center gap-0.5">
                          {[...Array(5)].map((_, i) => (
                            <FaStar
                              key={i}
                              className={`text-sm ${
                                i < review.rating ? "text-yellow-400" : "text-gray-300"
                              }`}
                            />
                          ))}
                        </div>
                      </div>
                      <FaGoogle className="ml-auto text-gray-400" />
                    </div>
                    <p className="text-gray-700 leading-relaxed line-clamp-4">
                      {review.text ? `"${review.text}"` : ""}
                    </p>
                    {review.relative_time_description && (
                      <p className="mt-2 text-xs text-gray-400">
                        {review.relative_time_description}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500">
              Nenhum review disponível no momento.
            </div>
          )}

          {/* Botão para ver mais reviews */}
          <div className="mt-8 sm:mt-12 text-center">
            <a
              href="https://www.google.com/search?q=alpha+translations+orlando+reviews"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-gray-200 rounded-full text-gray-700 font-medium hover:border-blue-400 hover:text-blue-600 transition-all duration-300"
            >
              <FaGoogle className="text-blue-500" />
              {t("home.reviewsViewAll")}
            </a>
            <p className="mt-3 text-sm text-gray-500">
              {t("home.reviewsBasedOn")}
            </p>
          </div>
        </div>
      </section>

      {/* Seção de FAQ (Perguntas Frequentes) — <details> nativo: conteúdo
          sempre no DOM (indexável) e casa com o schema FAQPage do index.html. */}
      <section className="w-full bg-white py-10 sm:py-20 md:py-24" id="faq">
        <div className="w-full px-4 md:px-6 mx-auto max-w-3xl">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900">
              {t("home.faqTitle")}
            </h2>
            <p className="mt-1 text-base sm:text-lg text-gray-600">
              {t("home.faqSubtitle")}
            </p>
          </div>
          <div className="space-y-3">
            {[1, 2, 10, 3, 11, 9, 4, 5, 6, 12, 8, 7].map((n) => (
              <details
                key={n}
                className="group rounded-2xl border border-gray-200 bg-gray-50 px-5 py-4 open:bg-white transition-colors"
              >
                <summary className="flex items-center justify-between cursor-pointer list-none text-gray-900 font-medium [&::-webkit-details-marker]:hidden">
                  <span>{t(`home.faq${n}Q`)}</span>
                  <span className="ml-3 flex-shrink-0 text-gray-400 transition-transform group-open:rotate-180">
                    ▾
                  </span>
                </summary>
                <p className="mt-3 text-gray-600 leading-relaxed">{t(`home.faq${n}A`)}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Nossos serviços — links internos para as landing pages de SEO. */}
      <section className="w-full bg-gray-50 py-10 sm:py-14 border-t border-gray-100" id="servicos">
        <div className="w-full px-4 md:px-6 mx-auto max-w-4xl text-center">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6">{seoUi.servicesTitle}</h2>
          <div className="flex flex-wrap justify-center gap-2.5">
            {LANDING_PAGES.map((p) => (
              <Link
                key={p.key}
                to={pathFor(seoLang, p.path)}
                className="inline-flex items-center px-4 py-2 rounded-full border border-gray-200 bg-white text-sm text-gray-700 hover:border-blue-400 hover:text-blue-600 transition-colors"
              >
                {NAV_LABELS[p.key]?.[seoLang] || NAV_LABELS[p.key]?.pt}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Seção de Contatos */}
      <ContactSection contacts={contacts} />

      {/* Botão flutuante do Instagram */}
      <a
        href="https://instagram.com/alpha.translations"
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram"
        className="fixed bottom-20 right-4 z-50"
      >
        <span className="sr-only">Visite nosso Instagram</span>
        <div className="h-14 w-14 rounded-full bg-pink-500 hover:bg-pink-600 flex items-center justify-center shadow-lg">
          <FaInstagram className="text-white h-7 w-7" />
        </div>
      </a>

      {/* Botão flutuante do WhatsApp */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="fixed bottom-4 right-4 z-50"
      >
        <span className="sr-only">Fale conosco no WhatsApp</span>
        <div className="h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center shadow-lg">
          <FaWhatsapp className="text-white h-7 w-7" />
        </div>
      </a>

      {/* Botão flutuante para voltar ao topo (esquerda) */}
      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Voltar ao topo"
        className="fixed bottom-4 left-4 z-50"
      >
        <span className="sr-only">Voltar ao topo</span>
        <div className="h-12 w-12 rounded-full bg-gray-700 hover:bg-gray-800 flex items-center justify-center shadow-lg">
          <FaArrowUp className="text-white h-6 w-6" />
        </div>
      </button>
    </div>
  );
};

export default Home;
